// extracted by mini-css-extract-plugin
export default {"lead":"WK0r8","list":"kh70B"};